import * as type from '../types';

// GET OPERATION HISTORY
export const setOperationHistorySelectedOrganization = organization => ({
    type: type.SET_OPERATION_HISTORY_SELECTED_ORGANIZATION,
    payload: organization
})

export const setOperationHistorySelectedUser = user => ({
    type: type.SET_OPERATION_HISTORY_SELECTED_USER,
    payload: user
})

export const setFilteredOperationType = value => ({
    type: type.SET_FILTERED_OPERATION_TYPE,
    payload: value
})

export const setFilteredImportance = value => ({
    type: type.SET_FILTERED_IMPORTANCE,
    payload: value
})

export const setFilteredSubject = value => ({
    type: type.SET_FILTERED_SUBJECT,
    payload: value
})

export const getOperationHistoryListRequest = reqParams => ({
    type: type.GET_OPERATION_HISTORY_LIST_REQUEST,
    payload: reqParams
})

export const getOperationHistoryListSucceeded = data => ({
    type: type.GET_OPERATION_HISTORY_LIST_SUCCEEDED,
    payload: data
})

export const getOperationHistoryListFailed = () => ({
    type: type.GET_OPERATION_HISTORY_LIST_FAILED
})